import React from 'react';
import {
  DateFilterControlled,
  DateFilterValues,
  FilterContainer,
  TankFilterValues,
  TankSelectorControlled,
} from '@components/Common/EntryFilters';
import FormLoader from '@components/Common/Loaders/FormLoader';
import { Columns } from '@components/Common/SharedStyles';
import { useTanksQuery } from '@api/queries/tanks';
import { useTerminalsQuery } from '@api/queries/terminals';

interface Props {
  tankFilter: TankFilterValues;
  dateFilter: DateFilterValues;
  onTankFilterChange: (value: TankFilterValues) => void;
  onDateFilterChange: (value: DateFilterValues) => void;
}

const EntryFilters: React.FC<Props> = ({
  tankFilter,
  dateFilter,
  onTankFilterChange,
  onDateFilterChange,
}) => {
  const { data: terminals = [], isLoading: isLoadingTerminals } = useTerminalsQuery();
  const { data: tanks = [], isLoading: isLoadingTanks } = useTanksQuery();

  const isLoading = isLoadingTerminals || isLoadingTanks;
  const hasNoData = terminals.length === 0 || tanks.length === 0;

  return (
    <FilterContainer>
      {isLoading && hasNoData && <FormLoader />}
      <Columns>
        <TankSelectorControlled
          terminals={terminals}
          tanks={tanks}
          value={tankFilter}
          onChange={onTankFilterChange}
        />
        <DateFilterControlled
          value={dateFilter}
          onChange={onDateFilterChange}
        />
      </Columns>
    </FilterContainer>
  );
};

export default EntryFilters;
